import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "User",
  initialState: {
    isLoggedIn: false,
    is_syncing: false,
    job_count: 0,
    remaining_job_count: 0,
    can_access: true,
    subscription_status: null,
    subscription_start_date: null,
    subscription_end_date: null,
    days_remaining: null,
    is_subscription_expired: false,
  },
  reducers: {
    SIGNIN_USER: (state, action) => {
      return { ...action?.payload, isLoggedIn: true };
    },
    SIGNINOUT_USER: (state, action) => {
      return { isLoggedIn: false };
    },
    UPDATE_USER_DATA: (state, action) => {

      return { ...state, ...action?.payload };
    },
    UPDATE_IS_SYNCING: (state, action) => {
      state.is_syncing = action.payload;
    },
    SET_JOB_COUNT: (state, action) => {
    
      state.job_count = action.payload;
    },
    SET_REMAINING_JOB_COUNT: (state, action) => {
      state.remaining_job_count = action.payload;
    },
    RESET_SYNC_PROGRESS: (state) => {
     
      state.job_count = 0;
      state.remaining_job_count = 0;
    },
    SET_SUBSCRIPTION_ACCESS: (state, action) => {
      const access = action?.payload ?? {};
      state.can_access = access.can_access ?? state.can_access;
      state.subscription_status = access.status ?? state.subscription_status;
      state.subscription_start_date =
        access.subscription_start_date ?? state.subscription_start_date;
      state.subscription_end_date =
        access.subscription_end_date ?? state.subscription_end_date;
      state.days_remaining = access.days_remaining ?? state.days_remaining;
      state.is_subscription_expired = Boolean(access.is_subscription_expired);
    },
  },
});

export const {
  SIGNIN_USER,
  SIGNINOUT_USER,
  UPDATE_USER_DATA,
  UPDATE_IS_SYNCING,
  SET_JOB_COUNT,
  SET_REMAINING_JOB_COUNT,
  RESET_SYNC_PROGRESS,
  SET_SUBSCRIPTION_ACCESS,
} = userSlice.actions;

export default userSlice.reducer;
